export default function initializeBoxElementIconSlider() {
    document.querySelectorAll('.block-box-element-icon-slider').forEach((block) => {
        const swiperEl = block.querySelector('.block-box-element-icon-slider__swiper');
        if (!swiperEl) return;
        new BoxElementIconSlider(block);
    });
}

class BoxElementIconSlider {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        import('swiper/bundle').then(({ default: Swiper }) => {
            this.initSwiper(Swiper);
        });
    }

    initSwiper(Swiper) {
        const slider = this.block.querySelector('.block-box-element-icon-slider__swiper');
        if (!slider) return;

        const wrapper = slider.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.querySelectorAll(':scope > *').forEach((el) => {
                el.classList.add('swiper-slide');
            });
        }

        const slidesPerView = slider.dataset.items ? parseInt(slider.dataset.items, 10) : 4;
        const validSlidesPerView = Number.isNaN(slidesPerView) || slidesPerView < 1 ? 4 : Math.min(slidesPerView, 8);

        new Swiper(slider, {
            speed: 400,
            loop: false,
            spaceBetween: 24,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            slidesPerView: validSlidesPerView,
            // pagination: {
            //     el: this.block.querySelector('.swiper-pagination'),
            //     clickable: true,
            // },
            pagination: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                    slidesOffsetBefore: 12,
                    slidesOffsetAfter: 12,
                },
                768: {
                    slidesPerView: Math.min(validSlidesPerView, 2) + 0.2,
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                992: {
                    slidesPerView: validSlidesPerView,
                    spaceBetween: 24,
                },
            },
        });
    }
}
